<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .buttons {
    width: 100%;
    max-width: utils.in_rem(160px);
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);
  }

  a {
    @include colors.color(primary_40);
  }
</style>

<script>
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { todosModalItemStore } from "../stores";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";

  // Utils
  import { startSearches } from "@sourcewhale/api";

  const handleSearch = (type) => {
    startSearches({
      candidateIds: [$todosModalItemStore.candidateId],
      contactTypes: type === "email" ? ["work", "personal"] : [type],
      current: true,
    });
  };

  const buttonConfig = {
    phone: {
      props: {
        kind: "primary",
        size: "small",
        leadingIcon: "fa-solid fa-search",
      },
      text: "Enrich Phone",
    },
    email: {
      props: {
        kind: "secondary",
        size: "small",
        leadingIcon: "fa-solid fa-search",
      },
      text: "Enrich Email",
    },
  };
</script>

<!-- Enrich Email button not shown if to-do is a phone call -->
<div class="buttons">
  {#each Object.entries(buttonConfig) as [type, config]}
    {#if !(type === "email" && $todosModalItemStore?.kind === "phoneCall")}
      {#if (type === "phone" && $userStore?.phoneCredits) || (type === "email" && $userStore?.emailCredits)}
        <Button
          onclick={() => handleSearch(type)}
          class="flex-1"
          {...config.props}
        >
          {config.text}
        </Button>
      {:else}
        <ButtonWithTooltip
          onclick={() => handleSearch(type)}
          placement="top"
          class="flex-1 disabled"
          {...config.props}
        >
          {config.text}
          <span slot="tooltip">
            {#if $userStore?.isAdmin}
              <a href="https://sourcewhale.app/admin#billing" target="_blank">
                Purchase credits
              </a>
              via the Admin panel
            {:else}
              Please ask your admin to purchase credits
            {/if}
          </span>
        </ButtonWithTooltip>
      {/if}
    {/if}
  {/each}
</div>
